import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CloudinaryResponse {
  secure_url: string;
  public_id: string;
  resource_type: string;
  created_at: string;
}

@Injectable({ providedIn: 'root' })
export class CloudinaryService {
  uploadMedia(file: File, category: string): Observable<CloudinaryResponse> {
    const folder = `aura_construction/${category.toLowerCase()}`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', environment.cloudinary.uploadPreset);
    formData.append('folder', folder);

    return from(
      fetch(`https://api.cloudinary.com/v1_1/${environment.cloudinary.cloudName}/upload`, {
        method: 'POST',
        body: formData
      }).then(async (response) => {
        if (!response.ok) {
          throw new Error('Cloudinary upload failed');
        }
        return response.json();
      })
    );
  }

  deleteMedia(publicId: string): Observable<{ result: string }> {
    return from(
      fetch(`https://api.cloudinary.com/v1_1/${environment.cloudinary.cloudName}/image/destroy`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          public_id: publicId,
          upload_preset: environment.cloudinary.uploadPreset
        })
      }).then(async (response) => {
        if (!response.ok) {
          throw new Error('Cloudinary delete failed');
        }
        return response.json();
      })
    );
  }
}
